"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _get = _interopRequireDefault(require("lodash/get"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _commons = require("../utils/commons");
var _consts = require("../utils/consts");
var _features = require("../utils/features");
var _locales = require("../utils/locales");
var _excluded = ["getToken", "switchBaseUrl", "getExtraHeaders"];
/**
 * Parse given options to SDK config
 */
var parseConfig = function parseConfig(_ref) {
  var getToken = _ref.getToken,
    switchBaseUrl = _ref.switchBaseUrl,
    getExtraHeaders = _ref.getExtraHeaders,
    options = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var config = (0, _extends2["default"])({}, options, {
    // Setup default values when needed
    region: options.region || _consts.DOCS_REGIONS.US,
    env: options.env || _consts.DOCS_ENVS.QA,
    locale: options.locale || 'en',
    headers: options.headers || {},
    timeout: options.timeout || 60 * 1000,
    withCredentials: options.withCredentials === true,
    cacheSize: options.cacheSize || 1000,
    // The maximum size of the cache
    cacheExpiration: options.cacheExpiration || 1000 * 60 * 30 // Maximum age in ms, 0.5 hour be default
  });
  config.product = options.product || (0, _commons.getProduct)() || _consts.DOCS_PRODUCTS.ACC;
  config.baseURL = options.baseURL || (0, _get["default"])(_consts.HOST_URL[config.region], config.env) || _consts.HOST_URL[config.env];

  // Setup config callbacks
  config.getEnv = function (key, defaultVal) {
    // Get env with region info
    var value = (0, _get["default"])(_consts.HOST_CONFIG, "".concat(config.region, ".").concat(config.env, ".").concat(key));
    // Check region if value existed at default config
    if (value === undefined) {
      value = (0, _get["default"])(_consts.HOST_CONFIG, "".concat(config.env, ".").concat(key));
    }
    return value === undefined ? defaultVal : value;
  };
  config.getToken = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof getToken !== 'function')) {
            _context.next = 2;
            break;
          }
          throw "Invalid getToken option. Use async function.";
        case 2:
          _context.next = 4;
          return getToken();
        case 4:
          return _context.abrupt("return", _context.sent);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  // Use callback to switch base url for individual service when needed (E.g. local debug)
  config.getBaseURL = function (pathKey) {
    var basePath = config.basePath,
      baseURL = config.baseURL,
      env = config.env,
      getEnv = config.getEnv;
    if (basePath !== undefined && basePath !== null) return "".concat(baseURL).concat(basePath);
    var url = typeof switchBaseUrl === 'function' ? switchBaseUrl({
      env: env,
      pathKey: pathKey
    }) : null;
    return url || "".concat(baseURL).concat(getEnv(pathKey));
  };

  // Callback to get extra header for individual service when needed (E.g. local debug)
  config.getHeaders = function (pathKey) {
    var headers = config.headers,
      env = config.env;
    if (typeof getExtraHeaders === 'function') {
      return (0, _extends2["default"])({}, headers, getExtraHeaders({
        pathKey: pathKey,
        env: env
      }));
    }
    return (0, _extends2["default"])({}, headers);
  };

  // Refresh locale and other config on initializing
  (0, _locales.setLocale)(config.locale);
  (0, _features.setFeatureFlags)(config.features);

  // Validate region support
  if (config.region !== _consts.DOCS_REGIONS.US && config.env === _consts.DOCS_ENVS.QA) {
    throw "No ".concat(config.env, " environment supported at region ").concat(config.region, ".");
  }
  return config;
};

/**
 * SDK config class
 */
var Config = exports["default"] = /*#__PURE__*/function () {
  function Config() {
    (0, _classCallCheck2["default"])(this, Config);
  }
  return (0, _createClass2["default"])(Config, [{
    key: "get",
    value:
    /**
     * Parse config through options
     */
    function get(options) {
      this.options = options || {};
      return parseConfig(this.options);
    }

    /**
     * Partial update options and regenerate latest config
     */
  }, {
    key: "update",
    value: function update(options) {
      this.options = (0, _merge["default"])(this.options, options);
      return parseConfig(this.options);
    }
  }]);
}();